import {iterChildren} from '@gongxigames/framework/core/fragments/BuilderY';
import {ActionFunction, runActions} from './Wrap';

export function Sequence(children: ActionFunction[]): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        const iterator = iterChildren<ActionFunction>(children);
        const actions = [...iterator];

        runActions(instance, actions, done);
    };

    return result;
};
